var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',{staticClass:"candidate opportunities apply-page"},[_c('v-container',{staticStyle:{"max-width":"900px"},attrs:{"grid-list-lg":"","fluid":""}},[(_vm.opportunity && _vm.opportunity.id)?_c('ApplicationForm',{staticStyle:{"margin":"auto"},attrs:{"opportunity":_vm.opportunity}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }